import { definitions } from '@luxuryescapes/contract-trip'

import { extractEndDateTime, extractStartDateTime, mapPlace } from '.'

import { PublicFullTrip, PublicTripItem } from 'tripPlanner/types/publicTrip'
import { assertUnreachable, makeDate } from 'tripPlanner/utils'

export const publicTripItem = (
  item: definitions['publicTripItem'],
  tripId: string,
): PublicTripItem => {
  switch (item.type) {
    case 'AIRBNB':
    case 'EVENT':
      return {
        ...item,
        place: mapPlace(item.place),
        tripId,
        ...extractStartDateTime(item),
        ...extractEndDateTime(item),
        startTimezone: item.startTimezone, // TODO: it shouldn't be optional in the contract. Remove this line when it's fixed
        endTimezone: item.endTimezone, // TODO: it shouldn't be optional in the contract. Remove this line when it's fixed
      }

    case 'EXPERIENCE':
      return {
        ...item,
        place: mapPlace(item.place),
        tripId,
        ...extractStartDateTime(item),
        ...extractEndDateTime(item),
        startTimezone: item.startTimezone, // TODO: it shouldn't be optional in the contract. Remove this line when it's fixed
        endTimezone: item.endTimezone, // TODO: it shouldn't be optional in the contract. Remove this line when it's fixed
      }
    case 'HOTEL':
      return {
        ...item,
        place: mapPlace(item.place),
        tripId,
        ...extractStartDateTime(item),
        ...extractEndDateTime(item),
        savedItemData:
          item.sourceType !== 'NA' ? item.savedItemData : undefined,
        startTimezone: item.startTimezone, // TODO: it shouldn't be optional in the contract. Remove this line when it's fixed
        endTimezone: item.endTimezone, // TODO: it shouldn't be optional in the contract. Remove this line when it's fixed
      }
    case 'RESTAURANT_BAR':
    case 'ATTRACTION':
      return {
        ...item,
        tripId,
        place: mapPlace(item.place),
        ...extractStartDateTime(item),
        startTimezone: item.startTimezone, // TODO: it shouldn't be optional in the contract. Remove this line when it's fixed
      }
    case 'BUS':
    case 'FERRY':
    case 'OTHER_TRANSPORT':
    case 'TRAIN':
    case 'ACTIVITY':
    case 'THING_TO_DO':
      return {
        ...item,
        tripId,
        startPlace: mapPlace(item.startPlace),
        endPlace: mapPlace(item.endPlace),
        ...extractStartDateTime(item),
        ...extractEndDateTime(item),
        startTimezone: item.startTimezone, // TODO: it shouldn't be optional in the contract. Remove this line when it's fixed
        endTimezone: item.endTimezone, // TODO: it shouldn't be optional in the contract. Remove this line when it's fixed
      }
    case 'FLIGHT':
      return {
        ...item,
        tripId,
        startPlace: mapPlace(item.startPlace),
        endPlace: mapPlace(item.endPlace),
        ...extractStartDateTime(item),
        ...extractEndDateTime(item),
        startTimezone: item.startTimezone, // TODO: it shouldn't be optional in the contract. Remove this line when it's fixed
        endTimezone: item.endTimezone, // TODO: it shouldn't be optional in the contract. Remove this line when it's fixed
      }
    case 'CAR_RENTAL':
    case 'CRUISE':
      return {
        ...item,
        tripId,
        startPlace: mapPlace(item.startPlace),
        endPlace: item.endPlace ? mapPlace(item.endPlace) : undefined,
        ...extractStartDateTime(item),
        ...extractEndDateTime(item),
        startTimezone: item.startTimezone, // TODO: it shouldn't be optional in the contract. Remove this line when it's fixed
        endTimezone: item.endTimezone, // TODO: it shouldn't be optional in the contract. Remove this line when it's fixed
      }
    case 'TOUR':
      return {
        ...item,
        tripId,
        startPlace: mapPlace(item.startPlace),
        endPlace: item.endPlace ? mapPlace(item.endPlace) : undefined,
        ...extractStartDateTime(item),
        ...extractEndDateTime(item),
        savedItemData:
          item.sourceType !== 'NA' ? item.savedItemData : undefined,
        startTimezone: item.startTimezone, // TODO: it shouldn't be optional in the contract. Remove this line when it's fixed
        endTimezone: item.endTimezone, // TODO: it shouldn't be optional in the contract. Remove this line when it's fixed
      }
    case 'NOTE':
      return {
        ...item,
        tripId,
        ...extractStartDateTime(item),
        ...extractEndDateTime(item),
        isSectionHeader: !!item.isSectionHeader,
      }
    default:
      return assertUnreachable(item)
  }
}

export const fullPublicTrip = (
  trip: definitions['fullPublicTrip'],
): PublicFullTrip => {
  const items = trip.items.map((i) => publicTripItem(i, trip.id))

  return {
    id: trip.id,
    name: trip.name,
    imageId: trip.imageId,
    items,
    startDate: trip.startDate ? makeDate(trip.startDate) : undefined,
    endDate: trip.endDate ? makeDate(trip.endDate) : undefined,
    startDay: trip.startDay,
    endDay: trip.endDay,
  }
}
